export const CONTENT_CONFIG = {
	subsanar: {
		titleModal: 'Subsanar documento',
		documenoLabel: 'Adjuntar documento subsanado',
		documentoErroneoLabel: 'Documento a subsanar',
		observacionTooltip: 'Las observaciones son obligatorias si no se dispone de la documentación solicitada.',
		submitLabel: 'Subsanar',
	},
	adicional: {
		titleModal: 'Documentación adicional',
		documenoLabel: 'Adjuntar documento solicitado',
		documentoErroneoLabel: '',
		observacionTooltip:
			'Las observaciones son obligatorias si no se dispone de la documentación adicional solicitada.',
		submitLabel: 'Enviar',
	},
};
